import React from 'react';
import { DualPriceStickyBar } from '@edreamsodigeo/frontend-prime';
import { useShoppingSummaryItinerary, useItineraryData, useSummaryPrice, useFlightSummarySelectedTotalPrice } from '@edreamsodigeo/frontend-checkout';
import { flightSummaryActions } from '../../../../boundaries/checkoutFlightSummary';
export const PrimeDualPriceStickyBarMobileWrapper = () => {
  const {
    data: shoppingSummaryItineraryData,
    loading: shoppingSummaryItineraryLoading
  } = useShoppingSummaryItinerary();
  const {
    transportTypes,
    isMultiDestination,
    isRoundTrip
  } = useItineraryData(shoppingSummaryItineraryData === null || shoppingSummaryItineraryData === void 0 ? void 0 : shoppingSummaryItineraryData.products);
  const {
    data: flightSummarySelectedTotalPriceData,
    loading: flightSummarySelectedTotalPriceLoading
  } = useFlightSummarySelectedTotalPrice({
    feeSelectionOverride: 'PRIME_PRICE'
  });
  const {
    pricePerPassenger,
    nonDiscountedPricePerPassenger,
    nonDiscountedPrice
  } = useSummaryPrice(flightSummarySelectedTotalPriceData === null || flightSummarySelectedTotalPriceData === void 0 ? void 0 : flightSummarySelectedTotalPriceData.getSummaryPrice);
  return /*#__PURE__*/React.createElement(DualPriceStickyBar, {
    loading: flightSummarySelectedTotalPriceLoading || shoppingSummaryItineraryLoading,
    onContinueWithFlight: flightSummaryActions.onContinueWithFlight,
    pricePerPassenger: pricePerPassenger,
    nonDiscountedPricePerPassenger: nonDiscountedPricePerPassenger,
    itineraryData: {
      transportTypes,
      isMultiDestination,
      isRoundTrip
    },
    trackedPrice: nonDiscountedPrice
  });
};